<template>
    <div class="intro-item global_pointer" @click="handleClick">
        <div class="detail">
            <span class="title">{{title}}</span>
            <span class="content">{{content}}</span>
        </div>
        <van-icon v-if="icon"  name="arrow" color="#A4A4A4"/>
    </div>
</template>
<script>

import { Icon } from 'vant';
export default {
    components: {
        [Icon.name]: Icon,
    },
    props: {
        title: String,
        content: String,
        icon: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleClick() {
            // 点击事件
            this.$emit('handle-click');
        }
    }
};
</script>
<style lang="less" scoped>
    img {
        display: block;
    }
    i {
        color: #A4A4A4;
    }
    .intro-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-height: 42px;
        font-size: 13px;
        line-height: 0.5px;
        color: #161A1A;
        .detail {
            text-align: left;
            display: flex;
            height: 100%;
            line-height: 25px;
            .title {
                width: 84px;
                color: #A4A4A4;
                font-family: "TradeGothicLT";
            }
            .content{
                line-height: 25px;
                max-width: 229.99px;
                font-family: "TradeGothicLT";
            }
        }
    }
</style>
